import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  flag1: {
    marginRight: "32px",
    width: "60px",
  },
  
  flag2: {
    marginRight: "32px",
    width: "65px",
  },

  flag3: {
    height: "36px",
    marginTop: "5px",
    marginRight: "32px"    
  }
});

class Lang extends Component{
    constructor(props){
       super(props);

       this.state = {};
       this.state.flag = 'images/Flag_of_Brazil.svg';

       this.imageClick = this.imageClick.bind(this);
    }

    imageClick(e){
      e.preventDefault();

      if (e.target.src.indexOf("Brazil")!==-1){
        this.props.setLanguage('pt-br');
      }
      if (e.target.src.indexOf("Spain")!==-1){
        this.props.setLanguage('es');
      }
      if (e.target.src.indexOf("United")!==-1){
        this.props.setLanguage('en');
      }

      // window.location.reload();
    }

    render(){
      const { classes } = this.props;

      return (
          <Grid container justify="center">
            <Grid key="f1" item>
              <img className={classes.flag1} 
                    src={"images/Flag_of_Brazil.svg"} 
                    alt="logo"
                    onClick={this.imageClick}>
              </img>
            </Grid>
            <Grid key="f2" item>
              <img className={classes.flag2} 
                    src={"images/Flag_of_Spain.svg"} 
                    alt="logo"
                    onClick={this.imageClick}>
              </img>
            </Grid>
            <Grid key="f3" item>
              <img className={classes.flag3} 
                    src={"images/Flag_of_the_United_States.svg"} 
                    alt="logo"
                    onClick={this.imageClick}>
              </img>
            </Grid>
          </Grid>
        // </Grid>
      );      
    }
}

export default withStyles(styles)(Lang);


// WEBPACK FOOTER //
// ./src/components/Lang/index.js